import IconButton from "@Components/shared/IconButton";
import { Done } from "@mui/icons-material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Progress, Tag } from "antd";
import React from "react";
import { IAssociatedStatuses } from "./hooks/useAssociatedStatuses";

interface ICMEStatusProps {
    info?: IAssociatedStatuses;
}

const CMEStatus = ({ info }: ICMEStatusProps) => {
    const { status, percentage } = info || {};
    if (!info || !status) {
        return null;
    }

    if (status === "completed") {
        return (
            <Tag
                icon={
                    <span>
                        <Done style={{ fontSize: "12px", marginRight: "4px" }} />
                    </span>
                }
                className="grey-tag"
            >
                CME Points Earned
            </Tag>
        );
    }

    if (["notStarted", "inProgress"].includes(status)) {
        return (
            <IconButton
                style={{ paddingBottom: status === "inProgress" ? "2rem" : "0", display: "flex" }}
                className="secondary border-grey"
                icon={<ChevronRightIcon />}
                position="right"
            >
                <div>Earn CME Points</div>
                {status === "inProgress" ? (
                    <div style={{ position: "absolute", bottom: 4 }}>
                        <Progress
                            percent={percentage ?? 0}
                            showInfo={false}
                            size="small"
                            strokeColor="#001529"
                            style={{ width: "125px" }}
                        />
                    </div>
                ) : null}
            </IconButton>
        );
    }

    return null;
};

export default CMEStatus;
